module.exports = __webpack_public_path__ + "static/media/promotion_under_30.ca19bd99.webp";